import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Form, notification } from "antd";
import { LookupRequest } from "../../../models/lookup-request";
import { buildAgencyRequest } from "../../../state/connect-api";
import { useFinalRegisterMutation, useRegisterMutation } from "../../../state/agencyApi";
import { recoveryQuestions } from "../../../common/constants/Helpers";

const useRegister = () => {
  const [registerForm] = Form.useForm();
  const [finalRegisterForm] = Form.useForm();
  const [isValidated, setIsValidated] = useState<boolean>(false);
  const navigate = useNavigate();
  const [registerAPI, { isLoading: isRegisterLoading }] = useRegisterMutation();
  const [finalRegisterAPI, { isLoading: isFinalRegisterLoading }] = useFinalRegisterMutation();

  const handleRegisterClick = async () => {
    const formValues = await registerForm.validateFields();
    const lookupRequest: LookupRequest = buildAgencyRequest(formValues.AGENCY_ID, formValues.REFERENCE_CODE, "Sample", "Sample", "Sample", "sample@test.com");
    const results = await registerAPI(lookupRequest).unwrap();
    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      finalRegisterForm.setFieldsValue({ AGENCY_ID: formValues.AGENCY_ID, REFERENCE_CODE: formValues.REFERENCE_CODE });
      setIsValidated(true);
    }
  };

  const handleFinalRegisterClick = async () => {
    const formValues = await finalRegisterForm.validateFields();
    const lookupRequest: LookupRequest = buildAgencyRequest(
      formValues.AGENCY_ID,
      formValues.REFERENCE_CODE,
      recoveryQuestions[formValues.QUESTION - 1].QUESTION,
      formValues.ANSWER,
      formValues.ANSWER,
      formValues.EMAIL
    );
    const results = await finalRegisterAPI(lookupRequest).unwrap();
    if (results.ERROR[0].ERROR) {
      notification.error({ message: results.ERROR[0].ERROR });
    } else {
      notification.success({ message: "Registration successful" });
      navigate("/login");
    }
  };

  const handleOnCancelClick = () => navigate("/login");

  return {
    registerForm,
    finalRegisterForm,
    isRegisterLoading,
    isFinalRegisterLoading,
    isValidated,
    handleRegisterClick,
    handleFinalRegisterClick,
    handleOnCancelClick
  };
};

export default useRegister;
